import React from 'react';
import Slider from 'react-slick';
import withSizes from 'react-sizes';

import CodeBlock from './CodeBlock'

import '../css/Uvp.css';

function Uvp(props){

  const request = `curl -X GET 'https://www.goldapi.io/api/price/XAU/USD' \n     -H 'x-access-token: YOUR_API_KEY`;

  const response = JSON.stringify({
    timestamp:1777005765,
    datetime:"2026-04-24T04:42:45Z",
    metal:"XAU",
    currency:"USD",
    exchange:"FOREXCOM",
    symbol:"FOREXCOM:XAUUSD",
    prev_close_price:4693.025,
    open_price:4693.025,
    low_price:4658.09,
    high_price:4711.21,
    open_time:1776988800,
    price:4665.825,
    unit:"troy_ounce",
    change:-27.2,
    change_percent:-0.58,
    ask:4666.32,
    bid:4665.36,
    price_per_unit: {
      troy_ounce:4665.825,
      gram:150.0098,
      kilogram:150009.8
    },
    melt_price_per_gram: {
      "24k":150.0098,
      "22k":137.5089,
      "18k":112.5073
    },
    currency_info: {
      code:"USD",
      name:"United States Dollar",
      symbol:"US$"
    }
  }, null, 2);

  return (
    <div className="uvp-parent landing-uvp">
      <>
        {props.isDesktop && 
          <div className="uvp-preview mt-3 mb-4 row justify-content-center align-items-center">
            <div className="landing-uvp-frame">
              <div>
                <CodeBlock language="js" value={`// Your Request
${request}`}/>
                <CodeBlock language="js" value={`// GoldAPI.io Response
${response}`}/>
              </div>
            </div>
          </div>
        }
        {props.isMobile && 
          <div className="landing-uvp-frame">
            <CodeBlock language="js" value={request}/>
            <CodeBlock language="js" value={response}/>
          </div>
        }
      </>
    </div>
  );
};

Uvp.defaultProps = {
  landing: true 
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 700,
  isDesktop: width >= 700
})


export default withSizes(mapSizesToProps)(Uvp);
